<script lang="ts">
    export let large: Boolean
</script>
{#if large != true}
<div class="divide-y divide-gray-300 border-2 rounded shadow-xl p-3 my-auto w-64 animate-pulse grid justify-items-stretch">
    <p class="mb-3 flex h-4 rounded bg-gray-200 w-1/3 justify-self-end"></p>
    <div class="mb-1 space-y-2">
        <p class="rounded h-4 bg-gray-300 w-3/4 mt-2">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
    </div>
    <div class="space-y-2">
        <p class="rounded h-4 bg-gray-300 w-3/4 mt-2">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
    </div>
</div>
{:else}
<div class="divide-y mt-3 divide-gray-300 p-3 my-auto w-auto animate-pulse grid justify-items-stretch">
    <p class="mb-3 flex h-4 rounded bg-gray-200 w-1/3 justify-self-end"></p>
    <div class="mb-3 space-y-2">
        <p class="rounded h-4 bg-gray-300 w-3/4 mt-2">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
    </div>
    <p class="mb-3 mt-6 flex h-4 rounded bg-gray-200 w-1/3 justify-self-end"></p>
    <div class="mb-3 space-y-2">
        <p class="rounded h-4 bg-gray-300 w-3/4 mt-2">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
        <p class="rounded h-4 bg-gray-200 w-3/5">
        </p>
    </div>
</div>
{/if}